<script>
export default {
    name: "UpdateServicePackagePricing",

    data() {

        return {
            pricing: {
                id: 0,
               // typeID: this.servicePackage.id,
                username: this.$root.username,
                active: true,
                recurent: true,
                qty: 0,
                DepartmentId:this.servicePackage.departmentID, 
                Department:this.servicePackage.department, 
            },
            itemName: "",
            items: [],
            servicePrices: [],
            filter:{
              searchText:'',
            }, errors: [],
           
        };
    },

    props: {

        servicePackage: Object,
        stores: Array,
        showModal: Boolean,
    },

    mounted() {

        this.fetchServicePricing();
    },

    methods: {

        fetchSearchedItems() {

            if(!this.itemName) return;

            this.$root.loading = true;
            this.$http.get(`Shared/GetSearchItems?SearchItems=${this.itemName}`).then(response => {
                this.items = response.data;
                this.$root.loading = false;
            }).catch(() => { this.$root.loading = false; });
        },

        saveData() {

            this.$root.loading = true;
            this.$http.post(`MasterData/DepartmentItemCharges`, this.pricing).then(() => {
                this.pricing = { 
                    id: 0, typeID: this.servicePackage.departmentID, 
                    username: this.$root.username, active: true, 
                    recurent: true, qty:0,
                    DepartmentId:this.servicePackage.department, 
                    Department:this.servicePackage.department, 

                };
                this.$root.loading = false;
                this.fetchServicePricing()
            }).catch(() => { this.$root.loading = false; });
        },

        fetchServicePricing() { 
            let url = `MasterData/GetDepartmentItemCharges`;
                url += `?DepartmentId=${this.servicePackage.departmentID}`;

            this.$http.get(url).then(response => {
                this.servicePrices = response.data;
            }).catch(() => {});
        },
    },
}
</script>
<template>
    <tail-modal :show="showModal" dimension="w-10/12 md:w-2/3">
      <template v-slot:title>
        <h5 class="font-bold text-sm">Update Departmental Item Charges: 
            <span class="text-blue-800">{{ servicePackage.department }}</span></h5>
      </template>
      <template v-slot:modal-body>
        <div class="flex flex-wrap -m-4">
            <div class="w-1/6 p-tiny">
                <label for="grid-item-pricing" class="label-control">Item:</label>
                <input type="text" id="grid-item-pricing" 
                    v-model="itemName" placeholder="Press enter to search" 
                    v-on:keyup.enter="fetchSearchedItems" 
                    class="input-control input-sm text-xs">
            </div>
            <div class="w-1/6 p-tiny mt-4">
                <tail-select>
                    <template v-slot:field>
                        <select v-model="pricing.itemId" class="input-sm input-control text-xs">
                            <option v-for="(item, idx) in items" :value="item.__ID" :key="idx">{{ item.itemName }}</option>
                        </select>
                    </template>
                </tail-select>
            </div>
            <div class="w-1/12 p-tiny">
                <label for="grid-quantity-pricing" class="label-control">Qty:</label>
                <input type="number" v-model="pricing.qty" id="grid-quantity-pricing" class="input-sm input-control text-xs text-right">
            </div>
            <div class="w-1/12 p-tiny">
                <label for="grid-charges" class="label-control">Charges:</label>
                <input type="number" v-model="pricing.charges" id="grid-charges" class="input-sm input-control text-xs text-right">
            </div>
            <div class="md:w-1/6 w-1/2  p-tiny">
              <label for="grid-store" class="label-control">Store:</label>
              <tail-select>
                <template v-slot:field>
                  <select v-model="pricing.storeId" id="grid-store" class="input-sm input-control text-xs">
                    <option value="">select store</option>
                    <option v-for="(store, idx) in stores" :key="idx" :value="store.id">{{ store.name }}</option>
                  </select>
                </template>
              </tail-select>
              <p class="form-text-error" v-if="errors.filter(error => error.field == 'storeId').length">
                  {{ errors.filter(error => error.field == 'storeID')[0].message }}</p>
            </div>
            <div class="w-1/6 p-tiny">
                <label for="grid-description-pricing" class="label-control">Description:</label>
                <textarea id="grid-description-pricing" v-model="pricing.description" cols="3" rows="1" class="input-control input-sm text-xs"></textarea>
            </div>
             
            <div class="w-1/12 p-tiny mt-4"> 
                <label for="grid-status-pricing" class="label-control">Active <input type="checkbox" id="grid-status-pricing" v-model="pricing.active"></label>
            </div>
            <div class="w-1/12 p-tiny mt-3">
                <button 
                    class="btn-sm btn-primary text-xs rounded" 
                    @click.prevent="saveData">
                    <i class="fa fa-plus"></i> Pricing
                </button>
            </div>
            <table class="table mt-2">
                <thead class="bg-blue-500 text-xs text-white">
                    <tr>
                        <th class="p-tiny">ID</th>
                        <th class="p-tiny">Item</th>
                        <th class="p-tiny">Charges</th>
                        <th class="p-tiny">Qty</th>
                        <th class="p-tiny">Description</th>
                        <th class="p-tiny">Store</th>
                        <th class="p-tiny">Active</th>
                        <th class="p-tiny">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(servicePrice, idx) in servicePrices" :key="idx">
                        <td>{{ servicePrice.id }}</td>
                        <td>{{ servicePrice.itemName }}</td>
                        <td>{{ servicePrice.charges }}</td>
                        <td>{{ servicePrice.qty }}</td>
                        <td>{{ servicePrice.description }}</td>
                        <td>{{ servicePrice.store }}</td>
                        <td>{{ servicePrice.active }}</td>
                        <td>
                            <button type="button" 
                                class="btn-sm text-xs btn-info rounded" 
                                title="Edit" 
                                @click.prevent="pricing = { ...servicePrice, userName: $root.username, }">
                                    <i class="fa fa-edit"></i> Edit
                            </button>
                            <!-- <button class="btn-sm btn-info text-xs" title="Edit" @click.prevent="pricing = servicePrice"><i class="fa fa-pen"></i></button> -->
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
      </template>
      <template v-slot:modal-footer>
          <button class="btn-sm btn-danger text-xs rounded" @click.prevent="$emit(`closeModal`)"><i class="fa fa-times"></i> Close</button>
      </template>
    </tail-modal>
</template>
